import { axiosInterceptor, apiCall } from 'services'
import { API_BASE_URL } from './constants'

const myPartnersService = () => {
	const api = axiosInterceptor(API_BASE_URL)

	// CREATE
	const addMyPartner = async (partner: any) => await apiCall(api.post(`/mypartners`, partner))

	// READ
	const initializeMyPartners = async () => await apiCall(api.get(`/mypartners`))
	const getMyPendingPartners = async (id: string) =>
		await apiCall(api.get(`/mypartners/pending/${id}`))
	/** A partner's profile and everything the two of you share (MYD-533). */
	const getPartnerShared = async (partnerUserId: string) =>
		await apiCall(api.get(`/mypartners/${partnerUserId}/shared`))

	// UPDATE
	const updateMyPartner = async (partner: any) => await apiCall(api.put(`/mypartners`, partner))

	// DELETE
	/** Withdraws a pending invitation the signed-in user sent. */
	const withdrawMyPartnerInvitation = async (partnershipId: string) =>
		await apiCall(api.delete(`/mypartners/${partnershipId}/withdraw`))

	/**
	 * Reminds the person of an invitation the signed-in user sent (MYD-547):
	 * the server emails them and adds it to their notifications. `asset` names
	 * the project or portfolio the reminder came from, when there is one.
	 * Resolves to `{ reminded }`: 0 when a reminder already went out this hour.
	 */
	const resendMyPartnerInvitation = async (partnershipId: string, asset?: { assetType: string; assetId: string }) =>
		await apiCall(api.post(`/mypartners/${partnershipId}/resend`, asset ?? {}))

	//OTHER
	const acceptMyPartner = async ({
		partnershipId,
		isAccepted,
	}: {
		partnershipId: string
		isAccepted: boolean
	}) =>
		await apiCall(
			api.patch(`/mypartners/accept`, {
				partnershipId: partnershipId,
				updates: {
					isAccepted: isAccepted,
				},
			}),
		)

	return {
		addMyPartner,
		initializeMyPartners,
		getMyPendingPartners,
		getPartnerShared,
		updateMyPartner,
		acceptMyPartner,
		withdrawMyPartnerInvitation,
		resendMyPartnerInvitation,
	}
}

export default myPartnersService
